import { Component, OnInit, Input } from '@angular/core';
import { TranslateService, LangChangeEvent, TranslationChangeEvent } from 'ng2-translate';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-language-strings',
  templateUrl: './language-strings.component.html',
})
export class LanguageStringsComponent implements OnInit {

  public translationStrings: any;
  public predicate: string = '';
  public reverse: string = '';
  public order: string = '+value';
  public languageString: any;
  public csv: string;

  constructor(
    private translate: TranslateService,
  ) {
  }

  ngOnInit() {

    this.languageString = {
      key: '',
      value: ''
    }
    
    // This event fire on Language Changes.
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      let res = event.translations;
      this.translationStrings = Object.keys(res)
        .map(function (key) {
          return { key, value: res[key] };
        })
    });
  }

  ngAfterViewInit() {
    this.getTranslationStrings();
  }

  getTranslationStrings() {

    let currentLang = this.translate.currentLang;
    let enUS = 'en';
    let svSE = 'se';

    if (enUS == currentLang) {
      this.translate.use(enUS);
      this.translate.reloadLang(enUS);
    } else {
      this.translate.use(svSE);
      this.translate.reloadLang(svSE);
    }
  }

  addString(languageString) {
    this.translationStrings.push(Object.assign({}, languageString));
    this.translationStrings.slice();
    this.languageString = {};
    this.order = this.reverse + this.predicate;
    this.orderBy(this.predicate);
    this.orderBy(this.predicate);
  }

  languageStringChange($event) {
    this.languageString.key = $event.toUpperCase().replace(/ /g, '_');
  }

  orderBy(predicate) {
    this.reverse = (this.predicate === predicate) ? (this.reverse == '+' ? this.reverse = '-' : this.reverse = '+') : '+';
    this.predicate = predicate;
    this.order = this.reverse + this.predicate;
  };

  csvToArray(csv) {
    let rows = csv.split("\n");
    let arrRows = rows.map(function (row) {
      return { key: row.split(",")[0], value: row.split(",")[1] };
    });
    this.translationStrings = arrRows;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/modules/development/language-strings/language-strings.component.ts